import * as React from 'react';
import { useCallback, useMemo, useState } from 'react';
import { Box, IconButton, Stack, TextField } from '@mui/material';
import { Location, useLocation } from 'react-router';
import { ContactProps } from '../components/ContactForm';
import AppBarPage from '../components/AppBarPage';
import { useTwilioChat } from '../hooks/useTwilio';
import ChatView from '../components/ChatView';
import { Message } from '../io/Api';
import { Send } from '@mui/icons-material';

const ChatPage = (): JSX.Element => {
    const loc: Location<ContactProps | undefined> = useLocation();
    const [text, setText] = useState('');
    const [fetching, setFetching] = useState(false);
    const { messages: twilioMessages, sendMessage, joined } = useTwilioChat(
        (loc.state && {
            user_name: `${loc.state.firstName} ${loc.state.lastName}`,
            company_name: loc.state.orgName || '',
            plan_name: loc.state.planName || '',
            service_type: loc.state.serviceType || ''
        }) || {}
    );

    const onMessageSent = useCallback(() => {
        setText('');
    }, []);

    const onSendClick = useCallback(() => {
        setFetching(true);
        sendMessage(text)
            .then(onMessageSent)
            // .catch(showError)
            .finally(() => setFetching(false));
    }, [onMessageSent, sendMessage, text]);

    const onTextChage = useCallback((event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setText(event.target.value);
    }, []);

    const onTextKeyDown = useCallback((event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter') {
            onSendClick();
        }
    }, [onSendClick]);

    const messages = useMemo<Message[]>(() =>
        twilioMessages.map(msg => ({
            text: msg.body || '',
            role: msg.author === 'bot' ? 'assistant' : 'user'
        })), [twilioMessages]);

    return (
        <AppBarPage title='Chat'>
            <Stack direction='column' sx={{
                position: 'absolute',
                right: 0,
                left: 0,
                top: '64px',
                bottom: 0
            }}>
                <ChatView messages={messages} typing={fetching} sx={{ flexGrow: 1 }} />
                <Box sx={{
                    display: 'flex',
                    padding: '8px'
                }}>
                    <TextField
                        name='message'
                        value={text}
                        disabled={!joined}
                        onChange={onTextChage}
                        onKeyDown={onTextKeyDown}
                        fullWidth
                        placeholder={joined ? 'Type a message here...' : 'Connecting...'}
                        focused />
                    <IconButton onClick={onSendClick}><Send /></IconButton>
                </Box>
            </Stack>
        </AppBarPage>
    )
}
export default ChatPage;